import { render, staticRenderFns } from "./SocialReviewEmbed.vue?vue&type=template&id=93cd25f6"
import script from "./SocialReviewEmbed.vue?vue&type=script&lang=js"
export * from "./SocialReviewEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports